import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

/**
 * HOC che inietta props di React Router v4 nei componenti class
 * per retrocompatibilità con v6.
 * 
 * Uso come HOC: export default RouterPropsWrapper(MyClassComponent);
 */
const withRouterProps = (Component) => {
  // Componente wrapper che usa gli hooks
  const WrapperComponent = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    
    const match = { 
      params,
      isExact: true,
      path: location.pathname,
      url: location.pathname
    };
    
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location: location,
      length: window.history.length,
    };
    
    return (
      <Component
        {...props}
        match={match}
        location={location}
        history={history}
        navigate={navigate}
        params={params}
      />
    );
  };
  
  WrapperComponent.displayName = `RouterPropsWrapper(${Component.displayName || Component.name || 'Component'})`;
  
  return WrapperComponent;
};

/**
 * Componente wrapper per usare nelle Routes direttamente
 * Uso nelle Routes: <Route path="/users/:id" element={<RouterPropsWrapper component={UserProfile} />} />
 */
export const RouterPropsWrapper = ({ component: Component, ...rest }) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  
  const match = { 
    params,
    isExact: true,
    path: location.pathname,
    url: location.pathname
  };
  
  const history = {
    push: (path, state) => navigate(path, { state }),
    replace: (path, state) => navigate(path, { replace: true, state }),
    go: (n) => navigate(n),
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location: location,
    length: window.history.length,
  };
  
  return (
    <Component
      {...rest}
      match={match}
      location={location}
      history={history}
      navigate={navigate}
      params={params}
    />
  );
};

// Export default per uso come HOC: export default RouterPropsWrapper(MyComponent)
export default withRouterProps;



